import gsap, { RoughEase, Linear } from 'gsap/all';
import {
    Mesh,
    MeshBasicMaterial,
    DoubleSide
} from 'three';

import { SCENE_INTERACTION } from '../../constants/scene';
import { VRObject3D } from './VRObject3D';

import { textureToggleGeometry, sceneChangeGeometry, lockedTexture, menuPositionCircleGeometry, emptyTexture, INDICATOR_HIT_SIZE } from './helpers/texturesAndGeometries';


class VRSceneChangeObject extends VRObject3D {

    constructor(containerName, camera, texture, x, y, z, model) {

        super(containerName);
        this.camera = camera;
        this.targetRoomId;
        this.locked = false;
        this.model = model;

        this.material = new MeshBasicMaterial({ map: texture, side: DoubleSide, transparent: true });
        this.mesh = new Mesh(sceneChangeGeometry, this.material);
        this.mesh.type = 'sceneChange';
        this.mesh.name = 'sceneChange';
        this.name = 'sceneChange';
        this.type = 'sceneChange';
        this.defaultTexture = texture;
        this.useIcon = true;
        this.customIcon = false;

        // INIT
        this.camera !== null ? this._setInitialPosRot() : this.setPosition(x, y, z);

        this.add(this.mesh);

        this.mesh.groupDetails = { title: $trans('scene-change'), icon: 'meeting_room', editTitle: $trans('edit-scene-change'), dataLang: 'edit-scene-change' }

        this.addElement('locakbleMesh', textureToggleGeometry, lockedTexture, 'lockable', 17, 17, 10);

        this.editControls();

        this.currentUser = null;


        model.addEventListener(SCENE_INTERACTION.JUMP_TO_OBJECT, (e) => {
            if (e.data.sceneId === this.targetRoomId) {
                const data = {
                    element: this.mesh,
                    onComplete: e.data.onComplete ? e.data.onComplete : null,
                };
                this.model.customSceneChange(data)
                console.log('custom scene change', data)
            }
        });
        model.addEventListener(SCENE_INTERACTION.SET_LOCKED_ROOMS, (e) => {
            const { lockedRooms } = this.model;
            this.unlock();
            if (!lockedRooms) return;
            if (lockedRooms[this.targetRoomId]) {
                this.lock();
            }
        }
        );
        model.addEventListener(SCENE_INTERACTION.SCENE_INITIALISED, (e) => {
            ///test if has locked rooms
            if (!e || !e.data || !e.data.payload) { return }
            const {
                data: { currentUsers: { lockedRooms } }
            } = e;
            if (!lockedRooms) {
                return
            }
            this.unlock()
            if (lockedRooms[this.targetRoomId]) {
                this.lock();
            }
        });
        return this;
    }

    setTargetRoomId = (id) => {
        this.targetRoomId = id;
    };

    getTargetId = (id) => {
        return this.targetRoomId;
    }

    lock() {
        if (this.model.userIsOwner) {
            return
        }
        this.locakbleMesh.visible = true;
        this.locked = true;
        $(`.indicator-${this.mesh.id}`).addClass("isLocked");
    }
    
    unlock() {
        $(`.indicator-${this.mesh.id}`).removeClass("isLocked");
        this.locakbleMesh.visible = false;
        this.locked = false;
    }

    onClick() {
        const { x, y, z } = this.locakbleMesh.position
        gsap.fromTo(this.locakbleMesh.position, { x: x + Math.PI / 4 }, {
            duration: .75,
            x: x,
            ease: RoughEase.ease.config({ strength: 8, points: 20, template: Linear.easeNone, randomize: false }),
            clearProps: "x"
        });
    }

    isDefaultSceneChangeImage = (url) => {
        return !url || String(url).includes('edit_change_scene');
    }

    getCustomImageUrl = () => {
        const url = this.dbConfig?.image?.url;
        return this.isDefaultSceneChangeImage(url) ? null : url;
    }

    isIndicatorMode = () => {
        return !!this.useIcon || !this.customIcon;
    }

    applyIndicatorHitGeometry = () => {
        this.updateMeshGeometry(INDICATOR_HIT_SIZE, INDICATOR_HIT_SIZE);
    }

    setUseIcon = (useIcon) => {
        const next = !!useIcon;
        if (this.useIcon === next) {
            this.customIcon = !next;
            return;
        }

        this.useIcon = next;
        this.customIcon = !next;
        if (this.dbConfig) this.dbConfig.useIcon = this.useIcon;
        this.updateMeshTexture();
    }

    updateMeshTexture = (imageLoadCallback = null) => {
        if (this.useIcon) {
            if (this.model?.editMode) {
                this.mesh.material.map = emptyTexture;
                this.applyIndicatorHitGeometry();
            } else {
                this.mesh.material.map = this.defaultTexture;
            }
            this.mesh.material.needsUpdate = true;
            imageLoadCallback && imageLoadCallback();
            return;
        }

        const url = this.getCustomImageUrl();
        const aspectRatio = this.dbConfig?.image?.aspectRatio || 1;
        if (url) {
            this.setGeometry(url, aspectRatio, true);
            imageLoadCallback && imageLoadCallback();
            return;
        }

        if (this.model?.editMode) {
            this.mesh.material.map = emptyTexture;
        } else {
            this.mesh.material.map = this.defaultTexture;
        }
        this.mesh.material.needsUpdate = true;
        imageLoadCallback && imageLoadCallback();
    }

    setDbConfig(config) {
        super.setDbConfig(config);

        if (config.useIcon !== undefined) {
            this.useIcon = config.useIcon === true;
        } else if (config.image !== undefined) {
            this.useIcon = !this.getCustomImageUrl();
        }
        this.customIcon = this.useIcon === false;
        this.dbConfig.useIcon = this.useIcon;
        this.updateMeshTexture();
    }

    addDummyPositionElement() {
        this.addElement('dummySceneChangeMesh', menuPositionCircleGeometry, emptyTexture, 'sceneChangeDummy', 0, 0, 0);
        this.dummySceneChangeMesh.rotation.copy(this.camera.rotation);
        this.dummySceneChangeMesh.lookAt(this.camera.position);
    }
}

export { VRSceneChangeObject };